export const STATE_OPEN = 1;
export const STATE_COMPLETED = 2;
export const TOTAL_FIELD_NAMES = [
  'hoursApproved',
  'hoursUsed',
  'hoursRemaining',
  'invoicedTime',
  'uninvoicedTime',
  'wontInvoiceTime',
];
